function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.35,
  stroke: "#556677",
  strokeWidth: 1.3
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.80077 13.4304L6.80078 16.1999",
  stroke: "#556677",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 9.8,
  y1: 11.8,
  x2: 9.8,
  y2: 16.2,
  stroke: "#556677",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 12.8,
  y1: 9.8,
  x2: 12.8,
  y2: 16.2,
  stroke: "#556677",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 15.8,
  y1: 7.8,
  x2: 15.8,
  y2: 16.2,
  stroke: "#556677",
  strokeWidth: 1.6,
  strokeLinecap: "round"
});
const SvgTrafficByClientIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrafficByClientIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/traffic-by-client-icon.397060e8.svg";
export { ForwardRef as ReactComponent };